import { Link, useNavigate } from 'react-router-dom';
import './login.css';
import { useState } from 'react';

export default function Login() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const [inCorrectEmail, setInCorrectEmail] = useState(false);
    const [emailId, setEmailId] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    function isValidEmail(email) {
        const emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    function handleOTP() {
        if (!isValidEmail(emailId)) {
            setInCorrectEmail(true);
            return;
        }

        setInCorrectEmail(false);
        setLoading(true);

        const dataToSend = {
            userId: emailId
        };

        fetch(`${BACKEND_URL}/login`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AUTH_TOKEN}`,
                'content-type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                navigate('/otp-verification', {
                    state: { emailId }
                });
            })
            .catch((error) => {
                console.log(error);
                alert('Error occurred!');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="login-logo-container">
                    <img
                        src="brand-icons/freslo-full-icon.png"
                        alt="logo"
                        className="login-logo"
                    />
                </div>

                <p className="login-heading">Welcome to Freslo</p>

                <p className="login-subtitle">
                    Fresh groceries delivered to your doorstep
                </p>

                <div className="login-input-wrapper">
                    <span className="login-input-icon">✉️</span>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        className="phone-input-login"
                        value={emailId}
                        onChange={(e) => setEmailId(e.target.value)}
                    />
                </div>

                {inCorrectEmail && (
                    <p className="login-error">
                        Please enter a valid email address
                    </p>
                )}

                <div className="login-otp-btn" onClick={handleOTP}>
                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        "Get OTP"
                    )}
                </div>

                <p className="login-terms">
                    By continuing, you agree to our{" "}
                    <Link to="/terms-and-conditions">
                        Terms & Conditions
                    </Link>{" "}
                    and{" "}
                    <Link to="/privacy-policy">
                        Privacy Policy
                    </Link>
                </p>
            </div>
        </div>
    );
}